ACC.registerPersona = {

    _autoload: [
        'initialize',
        'bindRegisterPersona',
        'bindCountryStates',
    ],

    spinner: $(`<img src='${ACC.config.commonResourcePath}/images/spinner.gif' />`),

    initialize() {
        if ($('#registerPersonaForm').data('isiamredirecton') === true) {
            if ($('#registerToken').length > 0 && piSession) {
                piSession.getToken((status, token) => {
                    $('#registerToken').val(token);
                    $('#registerUserId').val(piSession.userId());
                });
            }
        } else {
            $('#registerToken').val($('#registerPersonaForm').data('personapassword'));
            $('#registerUserId').val($('#registerPersonaForm').data('personausername'));
        }
    },

    getSubCategoriesUrl() {
        let url = window.location.href.toString();
        if (url.endsWith('/newPersona')) {
            url = url.substring(0, url.lastIndexOf('/newPersona'));
        }
        return `${url}/subCategories`;
    },

    populateComboWithSubCategories(categoryCode, combo) {
        if (categoryCode != null) {
            $.get(ACC.registerPersona.getSubCategoriesUrl(), {
                categoryCode,
            }, (data) => {
                if (data.length > 0) {
                    $(combo).parent().parent().show();
                    combo.prop('disabled', false);
                    combo.children('option').remove();
                    combo.append($('<option value="" selected="selected" label="Please select" />'));
                    $.each(data, (index) => {
                        combo.append($('<option/>', {
                            value: data[index].code,
                            text: data[index].name,
                        }));
                    });
                } else {
                    $(combo).parent().parent().hide();
                }
            });
        }
    },

    populateCategoriesAndSubcategories() {
        const registerCategoryCombo = $('#registerCategory');
        const registerSubCategoryCombo = $('#registerSubCategory');

        const registerCategoryComboVal = registerCategoryCombo.val();
        const registerSubCategoryComboVal = registerSubCategoryCombo.val();
        $(registerCategoryCombo.children('option')[0]).prop('disabled', false);

        if (registerCategoryComboVal && !registerSubCategoryComboVal) {
            ACC.registerPersona.populateComboWithSubCategories(registerCategoryComboVal, registerSubCategoryCombo);
        }

        registerCategoryCombo.change(() => {
            ACC.registerPersona.populateComboWithSubCategories(registerCategoryCombo.val(), registerSubCategoryCombo);
        });
    },

    bindRegisterPersona() {
        if ($('#registerToken').length > 0) {
            ACC.registerPersona.populateCategoriesAndSubcategories();
        }
    },

    bindCountryStates() {
        $('#defaultAddressCountrySelector').on('change', function () {
            ACC.registerPersona.displayStatesForChosenCountry(
                { countryIsoCode: $(this).val() },
                $('#countryAddressData'),
                ACC.registerPersona.spinner,
            );
        });
    },

    displayStatesForChosenCountry(options, countryAddressData, spinner) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/register/displayStates`,
            async: true,
            data: options,
            dataType: 'html',
            beforeSend() {
                countryAddressData.html(spinner);
            },
        }).done((data) => {
            countryAddressData.empty();
            countryAddressData.append($(data).html());
        });
    },
};
